<template>
    <div class="main-container">
        <div class="row no-wrap full-width">
            <!-- столбцы - белый поля сбоков -->
            <div class="col-lg-1 col-xl-1"></div>

            <div class="col-lg-10 col-xl-10 col-xs-12 col-sm-12 col-md-12">

                <!-- Выводим управляющие кнопки -->
                <dir class="row no-wrap justify-end q-mb-md">
                    <q-btn 
                        color='positive' 
                        label="Добавить нового"
                        icon="add"
                        @click='addNewClient'
                    />
                </dir>
            <!-- выводим основную таблицу с клиентами --> 

                <!-- Заголовок таблицы -->
                <div class="row no-wrap text-center table-title items-center">
                    <div class='col-xs-2 col-sm-2 col-md-2 col-lg-1 col-xl-1 border-right ellipsis'>
                        <q-icon name='menu'/>
                    <!-- под управляющие кнопки -->
                    </div>
                    <div class="col-lg-4 col-xl-4 col-md-7 col-sm-7 col-xs-10 q-pa-xs border-right ellipsis">Имя пользователя</div>
                    <div class="col-lg-3 col-xl-3 gt-xs col-md-3 col-sm-3 q-pa-xs border-right ellipsis">login / e-mail</div>
                    <div class="col-4 q-pa-xs ellipsis gt-md">Назначенные роли</div>
                </div>
                <!-- выводим основные данные -->
                <div 
                    v-for='item in users' 
                    :key='item.id' 
                    class='row no-wrap items-center text-truncate text-no-wrap contragent-line'
                    v-bind:class="{ blocked_line : item.blocked == 1 }"
                >

                    <div class="col-xs-2 col-sm-2 col-md-2 col-lg-1 col-xl-1 ellipsis border-right text-center">


                        <q-btn-dropdown  icon="menu" flat dense size='sm' color='primary' v-if='item.lock_at==null'>
                            <!-- dropdown content -->
                            <q-list link>
                                <q-list-header>
                                    Выбор действия
                                </q-list-header>
                                <q-item-separator />

                                <q-item v-close-overlay @click.native='toggleBlockUser(item)' size='sm'>
                                    <q-item-side icon="lock" inverted color="primary"  v-if='item.position == 0'/>
                                    <q-item-side icon="lock_open" inverted color="primary"  v-if='item.position == 1'/>
                                    <q-item-main>
                                        <q-item-tile label v-if='item.blocked == 0'>Заблокировать пользователя</q-item-tile>
                                        <q-item-tile sublabel v-if='item.blocked == 0'>Запретить доступ в систему</q-item-tile>
                                        
                                        <q-item-tile label v-if='item.blocked != 0'>Разблокировать пользователя</q-item-tile>
                                        <q-item-tile sublabel v-if='item.blocked != 0'>Разрешить доступ в систему</q-item-tile>

                                    </q-item-main>
                                </q-item>

                                <q-item v-close-overlay @click.native='editUser(item)' size='sm'>
                                    <q-item-side icon="edit" inverted color="positive" />
                                    <q-item-main>
                                        <q-item-tile>редактировать запись</q-item-tile>
                                    </q-item-main>
                                </q-item>

                                <!-- <q-item v-close-overlay @click.native='deleteUser(item)' size='sm'>
                                    <q-item-side icon="delete" inverted color="negative" />
                                    <q-item-main>
                                        <q-item-tile label >удалить запись</q-item-tile>
                                    </q-item-main>
                                </q-item> -->

                            </q-list>
                        </q-btn-dropdown>
                        <q-icon name='lock' v-if='item.lock_at!=null' color='red-10'/>
                    </div>
                    <div class="col-lg-4 col-xl-4 col-md-7 col-sm-7 col-xs-10 q-pa-xs border-right ellipsis">{{item.name}} {{item.surname}}</div>
                    <div class="col-lg-3 col-xl-3 gt-xs col-md-3 col-sm-3 q-pa-xs border-right ellipsis text-center">{{item.email}}</div>
                    <div class="col-4 gt-md q-pa-xs border-right ellipsis text-center">{{getRolesString(item)}}</div>
                </div>
            </div>
            
            <!-- белое поле справа -->
            <div class="col-lg-1 col-xl-1"></div>

        </div>
        <edit-dialog/>
    </div>
</template>

<script>
/* eslint-disable */
export default {

    name : 'userTerminal',

    components : {
        editDialog : ()=>import('./userEditDialog.vue'),
    },
    data() {
        return {
            dropDownOpen : false,
        }
    },

    created() {

        let list = this.$store.getters.allUsers;
        if (list.length ==0 ) { //Возможно список пользователей не загружен - загружаем его
                this.$store.dispatch('retrieveUsers')
                .then()
                .catch((error)=>{
                    console.log(error);
                    this.$admns.showNotify('Ошибка загрузки списка пользователей','error','Сообщение системы')
                });
        }   

        list = this.$store.getters.getRoles;
        if (list.length ==0 ) { //Возможно список пользователей не загружен - загружаем его
                this.$store.dispatch('retrieveRoles')
                .then()
                .catch((error)=>{
                    console.log(error);
                    this.$admns.showNotify('Ошибка загрузки списка ролей','error','Сообщение системы')
                });
        }   


    },
    
    computed :{

        users() {
            return this.$store.getters.allUsers;
        }

    },

    methods : {

        getRolesString(item) {
            
            let result = '';
            if (item.roles == undefined) return '';

            item.roles.forEach(element => {
                if (result.length > 0) result += ', ';
                let q = this.$store.getters.getRoleById(element);
                if (q != undefined) result += this.$store.getters.getRoleById(element).title;
            });

            return result;
        },

        getManager(id) {
            var result = this.$store.getters.getUserById(id);
            if (result == undefined) return '';
            else return result.name;
        },

        saveUser(item) {
            item.permissions = item.roles;
            this.$store.dispatch('saveUser', item)
            .then(()=>{
            })
            .catch((error)=>{
                console.log(error);
                this.$admns.showNotify('Ошибка сохранения данных','error','Сообщение системы');
            });

        },

        toggleBlockUser(item) {

            if (item.blocked == 0) item.blocked = 1; //устанавливаем флаг блокировки
            else item.blocked = 0;
            this.saveUser(item);

        },

        editUser(item) {
            // this.$store.dispatch('lockUser', item.id)
            eventBus.$emit('openUserEditDialog', item.id);
            // .catch(error=>{
            //     this.$admns.showNotify('Не удалось заблокировать запись','error', 'Сообщение системы');
            //     console.log(error);
            // })
        },

        addNewClient(){
            eventBus.$emit('openUserEditDialog', -1);
        },

        deleteUser(item) {
            this.$q.dialog({
                title: 'Внимание!',
                message: 'Подтвердите удаление контрагента "'+item.name+'"',
                ok : 'Удалить',
                cancel : 'Отмена'
            })
            .then(()=>{
               this.$store.dispatch('deleteContragent', item) 
               .then(()=>{
                   this.$admns.showNotify('Контрагент удален','success','Сообщение системы')
               })
               .catch(error=>{
                   console.log(error);
                   this.$admns.showNotify('Ошибка при удалении','error','Сообщение системы')
               });
            })
            .catch(()=>{})
        }
    }

}
</script>

<style lang="scss" scoped>
    .main-container {
        width : 100%;
        margin:auto;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
      }
    .text-center {
        text-align: center;
    }
    .table-title {
        background: #027be3;
        color:white;
        min-height: 35px;
    }
    .contragent-line {
        min-height: 35px;
        padding:5px;
        border : 1px solid rgb(189, 189, 189);
        border-top : 0px;
        font-size : 14px;
        &:hover{
            background: rgb(166, 252, 166);
        }
    }

    .blocked_line {
        background: rgb(255, 209, 209);
    }

    .border-right {
        border-right: 1px solid white;
    }
</style>
